import * as Moff from '../../constants/MoffAPI';
import { Doctor, Patient, Hospital, PatientDayTrainingLogs, PatientsDayTrainingLogs, Inquiry } from '../../interfaces';

/**
 * State
 */
export interface State {
  Loading: boolean;
  Loaded: boolean;
  patientDetails: Patient;
  doctorDetails: Doctor;
  hospitalDetails: Hospital;
  patients: Patient[];
  doctors: Doctor[];
  hospitals: Hospital[];
  patientDayTrainingLogs: PatientDayTrainingLogs[];
  patientsDayTrainingLogs: PatientsDayTrainingLogs[];
  inquiries: Inquiry[];
  inquiryDetails: Inquiry;
  loginedUserId: string;
  loginedUserName: string;
}

/**
 * Initial State
 */
const initialState = {
  Loading: false,
  Loaded: false,
  patientDetails: null,
  doctorDetails: null,
  hospitalDetails: null,
  patients: [],
  doctors: [],
  hospitals: [],
  patientDayTrainingLogs: [],
  patientsDayTrainingLogs: [],
  inquiries: [],
  inquiryDetails: null,
  loginedUserId: '',
  loginedUserName: ''
};

const moffApi = (state: State = initialState, action: any): State => {
  switch (action.type) {
    case Moff.FETCH_PATIENTS_SUCCESS:
      return { ...state, patients: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_DOCTORS_SUCCESS:
      return { ...state, doctors: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_PATIENT_DETAILS_SUCCESS:
      return { ...state, patientDetails: {...action.result}, Loading: false, Loaded: true };
    case Moff.FETCH_HOSPITAL_DETAILS_SUCCESS:
      return { ...state, hospitalDetails: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_DOCTOR_DETAILS_SUCCESS:
      return { ...state, doctorDetails: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_PATIENT_DAYTRAININGLOGS_SUCCESS:
      return { ...state, patientDayTrainingLogs: action.result, Loading: false, Loaded: true};
    case Moff.FETCH_PATIENTS_DAYTRAININGLOGS_SUCCESS:
      return { ...state, patientsDayTrainingLogs: action.result, Loading: false, Loaded: true};
    case Moff.FETCH_DOCTORS_SUCCESS:
      return { ...state, doctors: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_HOSPITALS_SUCCESS:
      return { ...state, hospitals: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_DOCTORS_IN_HOSPITAL_SUCCESS:
      return { ...state, doctors: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_INQUIRIES_SUCCESS:
      return { ...state, inquiries: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_INQUIRY_SUCCESS:
      return { ...state, inquiryDetails: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_USER_NAME_SUCCESS:
      return { ...state, loginedUserName: action.result, Loading: false, Loaded: true };
    case Moff.FETCH_USER_ID_SUCCESS:
      return { ...state, loginedUserId: action.result, Loading: false, Loaded: true };
    case Moff.SUCCESS:
      return { ...state, Loading: false, Loaded: true, };
    case Moff.LOADING:
      return { ...state, Loading: true, Loaded: false, };
    default:
      return state;
  }
};

export default moffApi;



// WEBPACK FOOTER //
// ./src/store/reducers/MoffApi.tsx